import { render } from "./AppMenu.vue?vue&type=template&id=46394f7e&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=46394f7e&lang=css"
import "./AppMenu.vue?vue&type=style&index=1&id=46394f7e&scoped=true&lang=scss"

import exportComponent from "D:\\eclipse\\workSpaceIDEA\\BioTechLeague_HUIDU_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46394f7e"]])

export default __exports__